<ng-container *transloco="let t">
    <div class="heading-container p-3"
         [ngClass]="{ 'clickable': type === MyUpcomingHeadingType.EVENT }"
    >
        <div
                class="d-flex align-items-start align-items-md-center {{ cssClass ? cssClass : '' }}"
                (click)="onHeadingClick()"
        >
            @if (type === MyUpcomingHeadingType.EVENT) {
            <div class="d-none d-md-flex">
              <ng-container *ngTemplateOutlet="imageHolderTemplate; context: { race: race, event: event }"></ng-container>
        </div>
            }

            <div class="ps-3 info">
                @if (type === MyUpcomingHeadingType.RACE) {
                <p class="info__small">{{ t('app.common.race') }}</p>
                }

                <p class="large text-uppercase pb-3 pb-md-0">
                    @if (type === MyUpcomingHeadingType.RACE && race) {
                    <app-language-output
                      [hrLabel]="race.name"
                      [enLabel]="race.nameEng"
                      [srLabel]="race.nameSr"
                      [itLabel]="race.nameIta"
                      [siLabel]="race.nameSlo"
                      [bsLabel]="race.nameBs"
                      [defaultLanguage]="event?.defaultLanguage"
                      [languages]="languages"
                    />
                    } @else if (type === MyUpcomingHeadingType.EVENT && event) {
                    <app-language-output
                      [hrLabel]="event.name"
                      [srLabel]="event.nameSr"
                      [bsLabel]="event.nameBs"
                      [enLabel]="event.nameEng"
                      [itLabel]="event.nameIta"
                      [siLabel]="event.nameSlo"
                      [defaultLanguage]="event.defaultLanguage"
                      [languages]="languages"
                    />
                    }
                </p>

                <div class="info__details d-flex flex-column flex-md-row align-items-start">
                    @if ( (type === MyUpcomingHeadingType.RACE && race?.sport) ||
                    (type === MyUpcomingHeadingType.EVENT && event?.sportOne) ) {
                    <!-- Sport badge reusable template -->
                    <ng-template #sportBadgeTemplate let-type="type" let-race="race" let-event="event" let-cssClass="cssClass">
                      <ng-container *ngIf="type === MyUpcomingHeadingType.RACE && race?.sport; else eventSport">
                        <p class="text-uppercase{{ cssClass ? ' ' + cssClass : '' }}">
                            {{ t('app.common.sports.' + race!.sport) }}
                        </p>
                        </ng-container>
                        <ng-template #eventSport>
                            <ng-container *ngIf="type === MyUpcomingHeadingType.EVENT && event?.sportOne">
                             <p class="text-uppercase{{ cssClass ? ' ' + cssClass : '' }}">
                            {{ t('app.common.sports.' + event!.sportOne) }}
                             </p>
                            </ng-container>
                        </ng-template>
                    </ng-template>

              <!-- Mobile sport badge -->
              <div class="d-flex d-md-none pb-2">
                <div class="badge-holder">
                  <div class="badge-holder__badge sport-badge info__details--block">
                    <ng-container
                      *ngTemplateOutlet="sportBadgeTemplate; context: { type: type, race: race, event: event, cssClass: cssClass }"
                  ></ng-container>
                </div>
              </div>
            </div>

            <!-- Desktop sport badge -->
            <div class="d-none d-md-flex info__details--block">
              <ng-container
                *ngTemplateOutlet="sportBadgeTemplate; context: { type: type, race: race, event: event, cssClass: cssClass }"
              ></ng-container>
            </div>
                    }

                    <!-- Start time -->
                    <div class="d-flex align-items-center info__details--block pb-1 pb-md-0">
                        <div class="d-flex pe-1">
                            <img src="assets/icons/icons-alt/calendar-04.svg" alt="Start time" />
                        </div>
                        <p class="regular {{ cssClass ? cssClass : '' }}">{{ dateString }}</p>
                        @if (type === MyUpcomingHeadingType.RACE) {
                        <p class="regular {{ cssClass ? cssClass : '' }}">
                        {{ race?.raceStart | localizedDate: 'HH:mm' }}
                        </p>
                        }
                    </div>

                    <!-- Location for EVENT -->
                    @if (type === MyUpcomingHeadingType.EVENT && (event?.city || country)) {
                    <div class="d-flex align-items-center info__details--block">
                      <div class="d-flex pe-1">
                        <img src="assets/icons/icons-alt/location-alt.svg" alt="Location" />
                      </div>
                      <p class="regular {{ cssClass ? cssClass : '' }}">
                    {{ event?.city ?? '' }}{{ event?.city && country ? ', ' : '' }}{{ country ?? '' }}
                    </p>
                  </div>
                    }

                    <!-- Distance for RACE -->
                    @if (type === MyUpcomingHeadingType.RACE) {
                    <div class="d-flex align-items-center info__details--block">
                      <div class="d-flex pe-1">
                        <img
                          src="assets/img/svg/distance.svg"
                          [alt]="t('app.map.elevation.graph.distance.m')"
                          [style.width]="'24px'"
                        />
                      </div>
                      <p class="regular {{ cssClass ? cssClass : '' }}">
                    {{ race?.length | raceLengthFormat: translocoService.getActiveLang() : 'km' }}
                    </p>
                  </div>
                    }

                    <!-- Participant count -->
                    @if (type === MyUpcomingHeadingType.RACE) {
                    <p class="regular {{ cssClass ? cssClass : '' }}">
                    {{ t('event.item.participants') }}:
              <span class="fw-medium ps-1">{{ race?.competitorCount?.total ?? '-' }}</span>
            </p>
                    }
                </div>
            </div>

            @if (type === MyUpcomingHeadingType.EVENT) {
            <div class="d-flex d-md-none">
              <ng-container *ngTemplateOutlet="imageHolderTemplate; context: { race: race, event: event }"></ng-container>
             </div>
             <div>
                <div class="d-md-flex d-none justify-content-center">
                    <!-- Action Buttons -->
                    <div class="d-flex flex-column flex-md-row align-items-end btn-holder">
                         <ng-container *ngTemplateOutlet="detailsButton"></ng-container>
                    </div>
                </div>
            </div>
            }

        </div>

        @if (type === MyUpcomingHeadingType.EVENT) {

        <div>
            <div class="d-md-none d-flex justify-content-end">
                <!-- Action Buttons -->
                     <ng-container *ngTemplateOutlet="detailsButton"></ng-container>
            </div>
        </div>
        }

        <ng-content></ng-content>
    </div>

    <ng-template #detailsButton>
        <div class="ps-0 ps-md-2 pt-3 pt-md-0">
            <app-button-alt
                    [buttonColor]="'var(--teal-500)'"
                    [textColor]="'white'"
                    [borderColor]="'var(--teal-500)'"
                    [isFullWidth]="true"
                    [text]="t('app.common.viewdetails')"
                    (onClickCallback)="goToEventDetails($event)"
                    [buttonHeight]="'36px'"
            ></app-button-alt>
        </div>
    </ng-template>

    <!-- Template: Image Holder -->
    <ng-template #imageHolderTemplate let-race="race" let-event="event">
        <div class="image_holder">
            <div class="circle-container">
                <div class="image-circle">
                    <ng-container *ngIf="race?.imageIcon !== null; else eventImage">
                        <img [src]="race!.imageIcon!" alt="" />
                    </ng-container>

                    <ng-template #eventImage>
                        <ng-container *ngIf="event?.imageIcon !== null; else defaultImage">
                            <img [src]="event!.imageIcon!" alt="" />
                        </ng-container>
                    </ng-template>

                    <ng-template #defaultImage>
                        <img src="assets/img/bg3.jpg" alt="" />
                    </ng-template>
                </div>
            </div>
        </div>
    </ng-template>
</ng-container>
